/**
 * Locale-aware date formatting anchored to America/Barbados so all
 * customer-facing timestamps read the same regardless of the device's
 * system timezone (BB is UTC-04:00 year round).
 *
 * Every dashboard component that renders a session timestamp goes
 * through here; the ReceiptSummary, ChargingSessionCard and
 * SessionDetailPage all share a single formatting policy.
 */

const TIMEZONE = 'America/Barbados';

function toDate(ts) {
  if (!ts) return null;
  if (ts instanceof Date) return Number.isNaN(ts.getTime()) ? null : ts;
  const d = new Date(ts);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function formatSessionDate(ts) {
  const d = toDate(ts);
  if (!d) return '—';
  try {
    return d.toLocaleDateString(undefined, {
      timeZone: TIMEZONE,
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  } catch { return '—'; }
}

export function formatSessionTime(ts) {
  const d = toDate(ts);
  if (!d) return '';
  try {
    return d.toLocaleTimeString(undefined, {
      timeZone: TIMEZONE,
      hour: 'numeric',
      minute: '2-digit',
    });
  } catch { return ''; }
}

export function formatSessionDateTime(ts) {
  const d = toDate(ts);
  if (!d) return '—';
  try {
    return d.toLocaleString(undefined, {
      timeZone: TIMEZONE,
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
    });
  } catch { return '—'; }
}

export const SESSION_TIMEZONE = TIMEZONE;
